import { useState } from "react"
import styled from "styled-components"
import { motion } from "framer-motion"
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
} from "recharts"
import { Calendar } from "lucide-react"
import { useEffect } from "react"

// const GA_SCOPE = "https://www.googleapis.com/auth/analytics.readonly";
// const GA_API_URL = "https://analyticsdata.googleapis.com/$discovery/rest?version=v1beta";
// const CLIENT_ID = "Im33Rc76Nc98Jc04Cc14Molly*";


// gapi.load("client:auth2", function () {
//   gapi.auth2.init({ client_id: CLIENT_ID }).then(() => document.dispatchEvent(new Event('gapi-loaded')));
// });

// function signIn(scope = GA_SCOPE) {
//   return gapi.auth2.getAuthInstance().signIn({ scope }).then(() => {
//     setCookie('guser-loggedin', 'true', 1);
//     location.reload();
//   }, (e) => console.error(e));
// }

// function signOut() {
//   return gapi.auth2.getAuthInstance().signOut().then(() => {
//     setCookie('guser-loggedin', 'true', -1);
//     location.reload();}, (e) => console.error(e));
// }

// function loadClient(apiPath = GA_API_URL) {
//   return gapi.client.load(apiPath);
// }

// function runReport(propertyId, query, cb = function (res) { console.log(res); }, err = function (err) { console.error(err); }) {

//   return loadClient().then(() => gapi.client.analyticsdata.properties
//     .runReport({
//       property: "properties/" + propertyId,
//       resource: query
//     })
//     .then(cb, err));
// }


// function isSignedIn() {
//   if (getCookie('guser-loggedin') === 'true') return true;
//   return false;
// }

// function setCookie(cname = 'guser-loggedin', cvalue, exdays) {
//   const d = new Date();
//   d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
//   let expires = "expires="+d.toUTCString();
//   document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
// }

// function getCookie(cname) {
//   let name = cname + "=";
//   let ca = document.cookie.split(';');
//   for(let i = 0; i < ca.length; i++) {
//     let c = ca[i];
//     while (c.charAt(0) == ' ') {
//       c = c.substring(1);
//     }
//     if (c.indexOf(name) == 0) {
//       return c.substring(name.length, c.length);
//     }
//   }
//   return "";
// }



// // 449-658-1313
// //  crodrigo9@gmail.com
// //  Im33Rc76Nc98Jc04Cc14Molly*

// function loadData() {
//   // Your GA property ID
//   const propertyId = "449-658-1313";

//   const startDate = "7daysAgo";
//   const endDate = "today";
//   const metrics = [
//     { name: "activeUsers" },
//     { name: "screenPageViews" },
//     { name: "sessions" },
//   ];

//   const query = {
//     dateRanges: [{ startDate, endDate }],
//     metrics: metrics,
//   };

//   runReport(propertyId, query, displayResult);
// }

// function displayResult(response) {
//   console.log(response)
// }


const PanelContainer = styled(motion.div)`
  background-color: #2A2B2E;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
`

const ChartGrid = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
`

const ChartContainer = styled.div`
  background-color: #3A3B3E;
  border-radius: 8px;
  padding: 20px;
  height: 400px;
`

const ChartTitle = styled.h3`
  color: #FFFFFF;
  margin-bottom: 20px;
  font-size: 1.2rem;
`

const MetricsGrid = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
`

const MetricContainer = styled(motion.div)`
  background-color: #3A3B3E;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const MetricValue = styled.h2`
  color: #4A88F3;
  font-size: 2.5rem;
  margin-bottom: 10px;
`

const MetricLabel = styled.p`
  color: #FFFFFF;
  font-size: 1rem;
  text-align: center;
`

const DateRangeSelector = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #3A3B3E;
  border-radius: 8px;
  padding: 10px;
`

const DateInput = styled.input`
  background-color: #2A2B2E;
  border: 1px solid #4A4B4F;
  border-radius: 4px;
  color: #FFFFFF;
  padding: 8px;
  font-size: 0.9rem;

  &:focus {
    outline: none;
    border-color: #4A88F3;
  }
`



// Datos simulados
const salesData = [
  { date: "2024-01", sales: 4000 },
  { date: "2024-02", sales: 3000 },
  { date: "2024-03", sales: 5000 },
  { date: "2024-04", sales: 4500 },
  { date: "2024-05", sales: 6000 },
  { date: "2024-06", sales: 5500 },
]

const topProductsData = [
  { name: "Bicicleta A", sales: 120 },
  { name: "Bicicleta B", sales: 98 },
  { name: "Bicicleta C", sales: 86 },
  { name: "Bicicleta D", sales: 75 },
  { name: "Bicicleta E", sales: 60 },
]

const customerSegmentationData = [
  { name: "Nuevos", value: 400 },
  { name: "Recurrentes", value: 300 },
  { name: "VIP", value: 100 },
]

const COLORS = ["#0088FE", "#00C49F", "#FFBB28"]

export const AnalyticsPanel = () => {
  const [startDate, setStartDate] = useState("2024-01-01")
  const [endDate, setEndDate] = useState("2024-06-30")

  useEffect(() => {
    // loadData()
  }, [])

  return (
    <PanelContainer initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
      <DateRangeSelector>
        <Calendar size={20} color="#FFFFFF" />
        <DateInput type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        <span style={{ color: "#FFFFFF" }}>to</span>
        <DateInput type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
      </DateRangeSelector>

      <MetricsGrid>
        <MetricContainer whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
          <MetricValue>$145,000</MetricValue>
          <MetricLabel>Ventas Totales</MetricLabel>
        </MetricContainer>
        <MetricContainer whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
          <MetricValue>1,234</MetricValue>
          <MetricLabel>Pedidos</MetricLabel>
        </MetricContainer>
        <MetricContainer whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
          <MetricValue>4.8</MetricValue>
          <MetricLabel>Calificación Promedio</MetricLabel>
        </MetricContainer>
        <MetricContainer whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
          <MetricValue>87%</MetricValue>
          <MetricLabel>Tasa de Conversión</MetricLabel>
        </MetricContainer>
      </MetricsGrid>

      <ChartGrid>
        <ChartContainer>
          <ChartTitle>Ventas Mensuales</ChartTitle>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart
              data={salesData}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" stroke="#FFFFFF" />
              <YAxis stroke="#FFFFFF" />
              <Tooltip contentStyle={{ backgroundColor: "#2A2B2E", border: "none" }} />
              <Legend />
              <Line type="monotone" dataKey="sales" stroke="#4A88F3" activeDot={{ r: 8 }} />
            </LineChart>
          </ResponsiveContainer>
        </ChartContainer>

        <ChartContainer>
          <ChartTitle>Top 5 Productos</ChartTitle>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={topProductsData}
              layout="vertical"
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" stroke="#FFFFFF" />
              <YAxis dataKey="name" type="category" stroke="#FFFFFF" />
              <Tooltip contentStyle={{ backgroundColor: "#2A2B2E", border: "none" }} />
              <Legend />
              <Bar dataKey="sales" fill="#4A88F3" />
            </BarChart>
          </ResponsiveContainer>
        </ChartContainer>

        <ChartContainer>
          <ChartTitle>Segmentación de Clientes</ChartTitle>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={customerSegmentationData}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
                label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
              >
                {customerSegmentationData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip contentStyle={{ backgroundColor: "#2A2B2E", border: "none" }} />
            </PieChart>
          </ResponsiveContainer>
        </ChartContainer>
      </ChartGrid>
    </PanelContainer>
  )
}

